import React, { forwardRef, useEffect, useState } from 'react';

import { connect } from 'react-redux';

import { StateModel } from '../../redux/store';

interface InputFieldTextProps {
  id?: string;
  label?: string;
  name?: string;
  classes?: string;
  inputType?: string;
  required?: boolean;
  maxlength?: number;
  onChangeHandler: (value: string) => void;
  onBlurHandler?: () => void;
  parentFocusHandler?: (value: string) => void;
  value?: string;
  resetValue?: string;
  autocompleteField?: any;
  autocompleteFormat?: any;
  autocompleteHandler?: any;
  readonly?: boolean;
  tooltip?: string;
  focusAfterTip?: () => void;
  onKeyDownHandler?: (event: any) => void;
}

const InputFieldText = forwardRef<HTMLInputElement, InputFieldTextProps>(
  (
    {
      id,
      label,
      name,
      classes = '',
      inputType = 'text',
      required = false,
      maxlength,
      onChangeHandler,
      onBlurHandler,
      parentFocusHandler,
      value,
      resetValue = '',
      autocompleteField,
      autocompleteFormat,
      autocompleteHandler,
      readonly = false,
      tooltip = '',
      focusAfterTip: focusAfterValidationTip,
      onKeyDownHandler,
    },
    ref
  ) => {
    const [showList, setShowList] = useState(false);

    useEffect(() => {
      if (value === undefined) onChangeHandler(resetValue);
    }, [value]);

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      onChangeHandler(event.target.value);
    };

    const onBlur = () => {
      onBlurHandler && onBlurHandler();

      setShowList(false);
    };

    const onListClick = (suchvorschlag: { [x: string]: string }) => {
      autocompleteHandler
        ? autocompleteHandler(suchvorschlag)
        : onChangeHandler(suchvorschlag[autocompleteField]);
      setShowList(false);
      parentFocusHandler && parentFocusHandler('');
    };

    const onFocusHandler = () => {
      setShowList(true);
      parentFocusHandler && name && parentFocusHandler(name);
    };

    return (
      <div className={`floating form-group ${classes}`} onBlur={onBlur}>
        <input
          title={tooltip}
          id={id}
          type={inputType}
          placeholder=' '
          required={required}
          maxLength={maxlength}
          value={value ?? ''}
          onChange={event => onChange(event)}
          onFocus={() => onFocusHandler()}
          readOnly={readonly}
          ref={ref}
          onKeyDown={onKeyDownHandler}
        />
        <label className='floating-label'>{label}</label>
      </div>
    );
  }
);

InputFieldText.displayName =
  InputFieldText.defaultProps?.name ?? 'InputFieldText';

const mapStateToProps = (state: StateModel) => ({});

export default connect(mapStateToProps, {}, null, {
  forwardRef: true,
})(InputFieldText);
